import Tesseract from 'tesseract.js';

export async function recognizeImage(imageFile, onProgress) {
  const { data: { text } } = await Tesseract.recognize(imageFile, 'jpn', {
    logger: ({ status, progress }) => {
      if (status === 'loading language traineddata') {
        onProgress?.({ phase: 'download', pct: Math.round(progress * 100) });
      } else if (status === 'recognizing text') {
        onProgress?.({ phase: 'ocr', pct: Math.round(progress * 100) });
      }
    },
  });
  return text.trim();
}
